/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnTranscoreUsers.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/pnn-transcore-users";

export class AutogenModelPnnTranscoreUsers<RowType extends ModelRow> extends Endpoint<RowType, RowPnnTranscoreUsersFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnTranscoreUsers extends ModelRow<RowPnnTranscoreUsersFields> {
	constructor(values?: Partial<RowPnnTranscoreUsersFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnTranscoreUsersFields {
	access_token: string;
	bp_profile: string;
	company_id: string;
	dat_password: string;
	dat_user_id: string;
	default_dispatch_layout: string;
	destination_radius: number;
	flash: string;
	highlight: string;
	loadboard_dat_id: string;
	loadboard_truckstop_rest_id: string;
	login_token_1: string;
	login_token_2: string;
	max_alarm_matches: number;
	message_visibility: string;
	new_order_next_action: string;
	origin_radius: number;
	partial: string;
	pnn_service_id: string;
	refresh_token: string;
	sms_message_limit: number;
	tm_profile: string;
	token_expiration: Date;
	transcore_password: string;
	transcore_user_id: string;
	truckstop_access_token: string;
	truckstop_refresh_token: string;
	truckstop_token_expires: Date;
	truckstop_user_email: string;
	truckstop_user_id: string;
	user_id: string;
}

